import React from "react";
import { Box, Typography } from "@mui/material";
import TruncatedText from "../../../Utils/TruncatedText";
import { useNavigate } from "react-router-dom";

const BuyAgain = (props) => {
  const { searchTerms, buyAgainList = [], mergedData = [], onIncrement, onDecrement } = props;



  //console.log("buyAgainList",buyAgainList)
 const navigate=useNavigate()

  
const GotoDetails = (e, data) => {
  e.stopPropagation(); // 👈 IMPORTANT
  const machineId = localStorage.getItem("machineId");
  navigate(`/productdetails/${machineId}/${data.mv_id}/${data.slot_id}`);
};


  return (
    <>
      {!searchTerms && buyAgainList.length > 0 && (
        <Box sx={{ mt: "10%" }}>
          <Typography
            variant="h6"
            sx={{
              fontSize: "17px",
              color: "rgba(113, 129, 152, 1)",
              fontFamily: "Roboto",
              letterSpacing: "0.2px",
              fontWeight: 500,
            }}
          >
            Buy Again!
          </Typography>

          {/* Horizontal Scroll Container */}
          <Box sx={{ width: "100%", overflowX: "auto", mt: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 2,
                height: "189px",
                p: 1,
              }}
            >
              {buyAgainList.map((el, index) => {
                console.log("el_______",el.mycount)
                const matched = mergedData.find((data) => data.slot_id === el.slot_id);
                const myCount = matched?.mycount || 0;
                const isAvailable = el.active_count > 0;

                return (
                  <Box
                    key={index}
                    //onClick={(e) => GotoDetails(e, el)}
                    sx={{
                      width: "141px",
                      borderRadius: "16px",
                      border: "1px solid rgba(56, 79, 111, 0.08)",
                      background: "#FFF",
                      boxShadow: "0px 4px 10px 0px rgba(56, 79, 111, 0.12)",
                      p: 1.5,
                      flexShrink: 0,
                      height: "180px",
                      cursor: "pointer",
                    }}
                  >
                    {/* Image */}
                    <Box sx={{ display: "flex", justifyContent: "center" }}   onClick={(e) => GotoDetails(e, el)} >
                      <img
                        src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${el.image_path}`}
                        alt={el.mv_name}
                        style={{
                          width: "73px",
                          height: "73px",
                          borderRadius: "10px",
                        }}
                      />
                    </Box>

                    {/* Product Name */}
                    <Typography
                      sx={{
                        textAlign: "center",
                        fontFamily: "Roboto",
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#333F4E",
                        mt: 1,
                      }}
                    >
                      <TruncatedText text={el.mv_name} limit={10} />
                    </Typography>

                    {/* Price */}
                    <Typography
                      sx={{
                        textAlign: "center",
                        fontFamily: "Roboto",
                        fontSize: "10px",
                        fontWeight: 400,
                        lineHeight: "16px",
                        color: "#718198",
                      }}
                    >
                      <TruncatedText
                        text={`₹ ${el.offer_price.toFixed(2)}`}
                        limit={34}
                      />
                    </Typography>

                    {/* Add / Counter Button */}
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                      {el.mycount > 0 ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "108px",
                            height: "32px",
                            borderRadius: "8px",
                            backgroundColor: "rgb(18, 154, 105)",
                            border: "1px solid rgba(0, 177, 119, 1)",
                            px: 2,
                          }}
                        >
                          <Typography
                            sx={{ color: "#FFF", cursor: "pointer" }}
                          onClick={(e) => onDecrement(e, index, el.slot_id,el.mycount)}
                          >
                            -
                          </Typography>
                          <Typography sx={{ color: "#FFF" }}>{el.mycount}</Typography>
                          <Typography
                            sx={{ color: "#FFF", cursor: "pointer" }}
                             onClick={(e) => onIncrement(e, index, el.slot_id, el.mycount, "add")}
                          >
                            +
                          </Typography>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            width: "108px",
                            height: "32px",
                            borderRadius: "8px",
                            border: "1px solid rgba(0, 177, 119, 1)",
                            backgroundColor: isAvailable
                              ? "rgba(0, 177, 119, 0.04)"
                              : "rgba(128, 128, 128, 0.24)",
                            color: isAvailable ? "rgb(0, 177, 119)" : "#fff",
                            textAlign: "center",
                            lineHeight: "32px",
                            cursor: isAvailable ? "pointer" : "not-allowed",
                          }}
                           onClick={(e) => onIncrement(e, index, el.slot_id, el.mycount, "add")}
                        >
                          ADD
                        </Box>
                      )}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default BuyAgain;
